module.exports = __webpack_public_path__ + "img/Norte.9ed51dd3.svg";